import script from "./ButContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButContent.vue?vue&type=script&setup=true&lang=js"

import "./ButContent.vue?vue&type=style&index=0&id=6a871b59&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a871b59"]])

export default __exports__